const installed = new WeakSet<Element>();
export function installMediaPlayers(root: ParentNode) {
  for (const player of root.querySelectorAll<HTMLElement>(
    ".compact-audio-player",
  )) {
    if (installed.has(player)) continue;
    installed.add(player);
    const audio = player.querySelector("audio")!;
    const fallback = () => {
      const frame = player
        .querySelector("template")
        ?.content.firstElementChild?.cloneNode(true);
      if (!frame || !player.isConnected) return;
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
      player.replaceWith(frame);
    };
    audio.addEventListener("error", fallback, { once: true });
    player.querySelector("button")!.addEventListener("click", fallback);
    if (audio.error) fallback();
  }
}

export function stopMediaPlayers(root: ParentNode) {
  for (const audio of root.querySelectorAll("audio")) {
    audio.pause();
    audio.removeAttribute("src");
    audio.load();
  }
}
